"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Image from "next/image";
import { DeliveryStatus } from "../../../../../../../../services/constants.js";
import { useImageConfig } from "../../../../../../../../utils/ImageConfigProvider/ImageConfigProviderClient.js";
import { getSwappedImageDomainUrl } from "../../../../../../../../utils/images/lib.js";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorGray700, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Box as Box$1 } from "@nxt-costco-com/forge-icons/icons/Box";
import { channelContainerStyles, channelWrapperStyles, priceMayVaryTextStyles } from "../styles.js";
import { iconSizeStyles, deliveryTextDivStyles } from "./styles.js";
const DeliveryChannelBadge = ({
  status,
  translations,
  uniqueId,
  showPriceMayVaryText,
  samedayDeliveryIcon
}) => {
  const { imageDomainSwapConfig } = useImageConfig();
  if (!status) return null;
  const {
    available,
    comingsoonlabel,
    unavailable,
    outofstock,
    deliverylabel,
    deliverypricingtext,
    viainstacart
  } = translations || {};
  const iconColor = status === DeliveryStatus.OutOfStock ? { color: ColorGray700 } : { color: ColorGray900 };
  const statusStylesMap = {
    [DeliveryStatus.Available]: {
      badgeColor: "success",
      badgeText: available
    },
    [DeliveryStatus.ViaInstacart]: {
      badgeColor: "default",
      badgeText: viainstacart
    },
    [DeliveryStatus.ComingSoon]: {
      badgeColor: "caution",
      badgeText: comingsoonlabel
    },
    [DeliveryStatus.OutOfStock]: {
      badgeColor: "caution",
      badgeText: outofstock
    },
    [DeliveryStatus.Unavailable]: {
      badgeColor: "light",
      badgeText: unavailable
    }
  };
  const { badgeColor, badgeText } = statusStylesMap[status];
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `DeliveryChannelBadgeContainer_${uniqueId}`,
      sx: channelContainerStyles,
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            "data-testid": `DeliveryChannelBadge_${uniqueId}`,
            sx: channelWrapperStyles,
            children: [
              samedayDeliveryIcon && status === DeliveryStatus.ViaInstacart ? /* @__PURE__ */ jsx(
                Image,
                {
                  "data-testid": `InstacartDeliveryIcon_${uniqueId}`,
                  width: 16,
                  height: 16,
                  src: getSwappedImageDomainUrl(
                    samedayDeliveryIcon,
                    imageDomainSwapConfig
                  ) || "",
                  alt: "",
                  unoptimized: true
                }
              ) : /* @__PURE__ */ jsx(Box$1, { sx: { ...iconSizeStyles, color: iconColor } }),
              /* @__PURE__ */ jsxs(Box, { sx: deliveryTextDivStyles, children: [
                /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: deliverylabel }),
                /* @__PURE__ */ jsx(Text, { color: badgeColor, variant: "t7", children: badgeText })
              ] })
            ]
          }
        ),
        showPriceMayVaryText && /* @__PURE__ */ jsx(Text, { color: "light", sx: priceMayVaryTextStyles, variant: "t7", children: deliverypricingtext })
      ]
    }
  );
};
export {
  DeliveryChannelBadge
};
